module.exports = __webpack_public_path__ + "img/medidas-sanitarias.png";